import * as e from "react";
import a from "../lib/IconBase.es.js";
import n from "../defs/ChartLineUp.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: n }));
o.displayName = "ChartLineUpIcon";
const p = o;
export {
  p as ChartLineUp,
  o as ChartLineUpIcon
};
